export default __webpack_public_path__ + "static/media/battery_30.d2eba987.svg";